import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import TestApp from './staging-helpers/TestApp';
import reportWebVitals from './reportWebVitals';
import './styles/main.scss';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('chatBotApp') as HTMLElement
);
root.render(
  <App/>
);

if (process.env.REACT_APP_MODE === 'testing') {
  const testAppRoot = ReactDOM.createRoot(
    document.getElementById('testApp') as HTMLElement
  );
  testAppRoot.render(
      <TestApp/>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
